// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emoji-picker {
  --emoji-menu-width: 472px;
  --emoji-menu-height: 309px;
  --emoji-search-input-height-container: 60px;
  min-width: var(--emoji-menu-width) !important;
  max-width: var(--emoji-menu-width) !important;
  min-height: var(--emoji-menu-height) !important;
  max-height: var(--emoji-menu-height) !important;
  overflow-x: hidden !important;
}

.emoji-picker .emoji-group-header {
  display: flex;
  height: var(--ant-control-height, 32px);
  padding: 5px 0px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
}

.emoji-picker .emoji-group-header .emoji-group-header-text {
  overflow: hidden;
  color: var(--ant-color-text-description, rgba(0, 0, 0, 0.45));
  text-overflow: ellipsis;
  font-family: var(--ant-font-family, 'SF Pro Text');
  font-size: var(--ant-font-size, 14px);
  font-style: normal;
  font-weight: var(--ant-font-weight-normal, 500);
  line-height: var(--ant-line-height, 22px); /* 157.143% */
}

.emoji-picker .emoji-item-wrapper {
  gap: 8px;
}

.emoji-picker .emoji-item {
  font-size: var(--ant-font-size-heading-4);
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/EmojiPicker/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2CAA2C;EAC3C,6CAA6C;EAC7C,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,uBAAuB;EACvB,kDAAkD;EAClD,qCAAqC;EACrC,kBAAkB;EAClB,+CAA+C;EAC/C,yCAAyC,EAAE,aAAa;AAC1D;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".emoji-picker {\n  --emoji-menu-width: 472px;\n  --emoji-menu-height: 309px;\n  --emoji-search-input-height-container: 60px;\n  min-width: var(--emoji-menu-width) !important;\n  max-width: var(--emoji-menu-width) !important;\n  min-height: var(--emoji-menu-height) !important;\n  max-height: var(--emoji-menu-height) !important;\n  overflow-x: hidden !important;\n}\n\n.emoji-picker .emoji-group-header {\n  display: flex;\n  height: var(--ant-control-height, 32px);\n  padding: 5px 0px;\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n}\n\n.emoji-picker .emoji-group-header .emoji-group-header-text {\n  overflow: hidden;\n  color: var(--ant-color-text-description, rgba(0, 0, 0, 0.45));\n  text-overflow: ellipsis;\n  font-family: var(--ant-font-family, 'SF Pro Text');\n  font-size: var(--ant-font-size, 14px);\n  font-style: normal;\n  font-weight: var(--ant-font-weight-normal, 500);\n  line-height: var(--ant-line-height, 22px); /* 157.143% */\n}\n\n.emoji-picker .emoji-item-wrapper {\n  gap: 8px;\n}\n\n.emoji-picker .emoji-item {\n  font-size: var(--ant-font-size-heading-4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
